import React from 'react';
import CreateOperationComponent from './CreateOperationComponent';
import { getOperationText, mapToFilter } from '../../common/Helpers';
import { apiFetch as fetch } from '../../common/Helpers';

class CreateOperationPage extends React.Component {

    render() {

        return (
            <CreateOperationComponent operation={
                {
                    actions: [],
                    productFilters: [],
                    productFiltersLogicalOperator: "And"
                }
            }   onSubmit={this.handleSubmit}
                onCreate={this.handleCreate} />
        );
    }

    saveAndExecute = (operation, autoExecute) => {
        const mappedFilters = operation.productFilters.map(mapToFilter);
        const filter = {
            "filterType": "composite",
            "logicalOperator": operation.productFiltersLogicalOperator,
            "children": mappedFilters
        };
        let description = operation.description;
        if (description === "" || description === null) {
            description = getOperationText(operation);
        }
        fetch(`api/operations/tag`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                description: description,
                actions: operation.actions,
                filter: filter,
                autoExecute: autoExecute
            })
        }).then(_ => {
            this.props.history.push("/operations");
        });
    }

    handleSubmit = (operation) => {
        this.saveAndExecute(operation, true);
    }

    handleCreate = (operation) => {
        this.saveAndExecute(operation, false);
    }

    handleOnEdit = async () => {
    }

    componentDidMount() {
        // fetch(`api/products/tagOperationData`, {
        //     method: 'GET'
        // })
        //     .then(response => response.json())
        //     .then(data => this.setState({
        //         variants: data.variants,
        //         tags: data.tags,
        //         selectedOptions: data.selectedOptions,
        //         loading: false
        //     }));
    }
}

CreateOperationPage.defaultProps = {

}

export default CreateOperationPage;